import React from 'react';

import { FormattedMessage } from 'react-intl';

import SectionMessage from '@atlaskit/section-message';

import messages from './commit-page.i18n';

export const UnreachableCommitWarning = (): JSX.Element => {
  return (
    <SectionMessage appearance="warning">
      <FormattedMessage {...messages.unreachableWarning} />
    </SectionMessage>
  );
};
